export const Close = (props) => (<svg height="30" viewBox="0 0 413.348 413.348" width="30" version="1.1" strokeWidth={1.5} {...props} xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor">
            <path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/>
        </g>
    </svg>);
